export enum UserEventActionTypeEnum {
    // add contacts to list
    ADD = 'ADD',
    // remove contacts from list
    REMOVE = 'REMOVE',
    // delete a saved search or list
    DELETE = 'DELETE'
}
